export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop Here" },
  { to: "/pop-up-shop", label: "Pop-Up Shop" },
  { to: "/shop-within-a-shop", label: "Shop Within a Shop" },
  { to: "/beauty-rentals", label: "Beauty Rentals" },
  { to: "/events", label: "Events" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
];

export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_b51a1e85-dd00-45c0-ab52-b9f823d7229c/artifacts/12ro8uqe_Copy%20of%20E%20%283%29.png";

export const CONTACT = {
  email: "rentals@essandtials.com",
  instagram: "essandtials",
  instagramUrl: "https://www.instagram.com/essandtials",
  whatsappDisplay: "+1 (441) 519-1794",
  whatsappUrl: "https://wa.me/14415191794",
  address: "39 Dundonald Street, Hamilton, Bermuda",
  mapsEmbed:
    "https://www.google.com/maps?q=39%20Dundonald%20Street%2C%20Hamilton%2C%20Bermuda&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=39+Dundonald+Street+Hamilton+Bermuda",
  hours: [
    { days: "Monday — Friday", time: "10:00 AM – 6:00 PM" },
    { days: "Saturday", time: "10:00 AM – 8:00 PM" },
    { days: "Sunday", time: "12:00 PM – 4:00 PM" },
  ],
};
